export const DOMAIN = 'FitbitSetup';
export const SETUP_TEXT = 'Set up a Fitbit to track your sleep easier.';
